module.exports = __webpack_public_path__ + "img/warehouse.c855b125.svg";